<template>
  <div
    v-if="isText"
    class="input-group-text"
  >
    <slot />
  </div>
  <slot v-else />
</template>

<script>
export default {
  name: 'BInputGroupAppend',
  props: {
    isText: { type: Boolean, default: false },
  },
}
</script>
